/* React */
import React from "react";

/* React-Redux */
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "src/redux/store";

import { setShowNoValueEntries } from "src/redux/features/insights-options/descriptive-statistics/descriptiveStatisticsOptionsSlice";

/* Components */
import ShowNoValueEntries from "src/components/insights/insights-options/descriptive-statistics/show-no-value-entries/ShowNoValueEntries";

/* Hooks */
import { useIsCustomCohortActive } from "src/utils/hooks/useIsCustomCohortActive";

/* Stylesheet */
import styles from "./DescriptiveStatisticsOptions.module.scss";

const DescriptiveStatisticsOptions: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const descriptiveStatisticsOptionsState = useSelector(
    (state: RootState) => state.descriptiveStatisticsOptions
  );

  const { showNoValueEntries } =
    descriptiveStatisticsOptionsState;

  const isCustomCohortActive = useIsCustomCohortActive();

  return (
    <div className={styles.descriptive_statistics_options}>
      <ShowNoValueEntries
        showNoValueEntries={showNoValueEntries}
        disabled={isCustomCohortActive}
        handleShowNoValueEntries={() =>
          dispatch(
            setShowNoValueEntries(!showNoValueEntries)
          )
        }
      />
    </div>
  );
};

export default DescriptiveStatisticsOptions;
